/* eslint-disable linebreak-style */
import {
  UPLOAD_EQUIPMENT_FILE,
  UPLOAD_EQUIPMENT_FILE_SUCCESS,
  UPLOAD_EQUIPMENT_FILE_FAILURE,
  COPY_CHECKS,
  COPY_CHECKS_SUCCESS,
  COPY_CHECKS_FAILURE,
} from './types';

const uploadEquipmentfile = (payload) => ({
  type: UPLOAD_EQUIPMENT_FILE,
  ...payload,
});

const uploadEquipmentfileSuccess = (payload) => ({
  type: UPLOAD_EQUIPMENT_FILE_SUCCESS,
  ...payload,
});

const uploadEquipmentfileFailure = () => ({
  type: UPLOAD_EQUIPMENT_FILE_FAILURE,
});

const copyChecks = (data) => ({
  type: COPY_CHECKS,
  payload: data,
});

const copyChecksSuccess = (data) => ({
  type: COPY_CHECKS_SUCCESS,
  payload: data,
});

const copyChecksFailure = (error) => ({
  type: COPY_CHECKS_FAILURE,
  payload: error,
});

export {
  uploadEquipmentfile,
  uploadEquipmentfileSuccess,
  uploadEquipmentfileFailure,
  copyChecks,
  copyChecksSuccess,
  copyChecksFailure,
};
